import { useEffect } from 'react';

/* useWindowBlur will execute a callback when the window is blurred
 * @param {function} onBlur Callback to run when window is blurred
 */
export default function useWindowBlur(onBlur) {
  useEffect(() => {
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('blur', onBlur);
    };
  }, []);
}
